import { render, staticRenderFns } from "./bindLogistics.vue?vue&type=template&id=61027c4d&scoped=true"
import script from "./bindLogistics.vue?vue&type=script&lang=js"
export * from "./bindLogistics.vue?vue&type=script&lang=js"
import style0 from "./bindLogistics.vue?vue&type=style&index=0&id=61027c4d&prod&scoped=true&lang=css"
import style1 from "./bindLogistics.vue?vue&type=style&index=1&id=61027c4d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61027c4d",
  null
  
)

export default component.exports